var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQualityStepsIcon5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8975 10.7412L14.16 17.8462C14.1742 17.9299 14.1624 18.0159 14.1264 18.0927C14.0903 18.1695 14.0317 18.2335 13.9583 18.276C13.8849 18.3186 13.8003 18.3378 13.7157 18.331C13.6311 18.3241 13.5507 18.2917 13.485 18.2379L10.5017 15.9987C10.3577 15.8911 10.1827 15.833 10.003 15.833C9.82318 15.833 9.64822 15.8911 9.5042 15.9987L6.51587 18.237C6.4503 18.2907 6.36992 18.3232 6.28545 18.33C6.20098 18.3368 6.11643 18.3177 6.04309 18.2753C5.96975 18.2328 5.9111 18.169 5.87497 18.0923C5.83884 18.0157 5.82694 17.9298 5.84087 17.8462L7.10254 10.7412",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.667C12.7614 11.667 15 9.42842 15 6.66699C15 3.90557 12.7614 1.66699 10 1.66699C7.23858 1.66699 5 3.90557 5 6.66699C5 9.42842 7.23858 11.667 10 11.667Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityStepsIcon5);
export default __webpack_public_path__ + "static/media/qualityStepsIcon5.23e39b8c04db414f6ef9e6557fc9012f.svg";
export { ForwardRef as ReactComponent };